import axios from 'axios'
import router from './../../../router'
import {Errors} from "../../../components/validations/forms";

const namespaced = true;

const state = {
  idToken: null,
  expiryDate: null,
  };

const getters = {
  isAuthenticated (state) {
    const now = new Date();
    if(state.idToken !== null && state.expiryDate > now){return true}
  }
};

const mutations = {
    authUser (state, userData) {
      state.idToken = userData.token
      state.expiryDate = userData.expiryDate
    },
    clearAuthData (state) {
      state.idToken = null
      state.expiryDate = null
    }
  };


const actions = {


    setLogoutTimer ({commit}, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData')
      }, expirationTime * 1000)
    },


    validateCard ({commit, dispatch}, authData) {
      return new Promise((resolve, reject) => {
        axios.post('/api/card/verify', {
          card: authData.card,
            mobile: authData.mobile,
            countryCode: authData.countryCode,
            lang: authData.lang,
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
      })
    },



    // validateCard ({commit, dispatch}, payload) {
    //     return new Promise((resolve, reject) => {
    //         let params = new URLSearchParams();
    //         axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
    //         axios.post('/api/card/verify', {
    //             card: payload.card,
    //             mobile: payload.mobile,
    //         })
    //             .then(res => {
    //                 // commit('setLeaveTypes', res.data.data)
    //                 console.log('validateCard - validateCard.');
    //                 resolve(res.data.data);
    //             })
    //             .catch(error => {
    //                 const issues = new Errors();
    //                 issues.record(error.response);
    //                 reject(issues);
    //             })
    //     })
    // },




    validateOTP ({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/api/card/verify', {
                card: authData.card,
                mobile: authData.mobile,
                countryCode: authData.countryCode,
                code: authData.code,
                lang: authData.lang,
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },

    signup ({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/api/user', {
                card: authData.card,
                firstName: authData.firstName,
                lastName: authData.lastName,
                email: authData.email,
                password: authData.password,
                birthday: authData.birthday,
                gender: authData.gender,
                nationalities_id: authData.nationality,
                iqamaID: authData.iqama,
                maritalStatus: authData.marital,
                language: authData.language,
                mobile: authData.mobile,
                countryCode: authData.countryCode,
                line1: authData.street,
                city: authData.city,
                country: authData.country,
                postcode: authData.postcode,
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },

    requestEmail ({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/api/user/requestEmail', {
                mobile: authData.mobile,
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },


    requestPassword ({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/api/user/requestPassword', {
                mobile: authData.mobile,
                token: authData.token,
                status: authData.status,
                password: authData.password,
                password2: authData.password_confirmation,
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        })
    },

    login ({commit, dispatch}, authData) {
      return new Promise((resolve, reject) => {

          axios.post('/oauth/token', {
            username: authData.email,
            password: authData.password,
            grant_type: "password",
            client_id: "2",
            client_secret: "mMOWxWdVX48xFbwq2rmQSphiKJpJowFXkjATS8tS",
            scope: "*"
        })
          .then(res => {
            const now = new Date()
            const expirationDate = new Date(now.getTime() + res.data.expires_in * 1000)
            localStorage.setItem('token', res.data.access_token)
            localStorage.setItem('expirationDate', expirationDate)
            commit('authUser', {
              token: res.data.access_token,
              expiryDate: expirationDate
            })
            dispatch('setLogoutTimer', res.data.expires_in)
            location.reload()
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
      })
    },
    tryAutoLogin ({commit}) {
      const token = localStorage.getItem('token')
      if (!token) {
        return
      }
      const expirationDate = new Date(localStorage.getItem('expirationDate'))
      const now = new Date()
      if (now >= expirationDate) {
        return
      }

      commit('authUser', {
        token: token,
        expiryDate: expirationDate,
      })
    },
    logout ({commit}) {
      commit('clearAuthData')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem('token')
      router.replace('/')
      location.reload()
      //   alert('Logged Out')
    }
  };


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/auth.js